<template>
  <div class="home" @dblclick="aniIndex = false">
    <el-amap
      v-if="$store.state.user.userInfo.natureId == 1 || $store.state.user.userInfo.natureId == 3"
      class="amap-box"
      vid="amap"
      :zoom="zoom"
      :resizeEnable="true"
      :center="position"
      @click="chous"
    >
      <el-amap-marker vid="component-marker" :position="position" :icon="icon" v-if="isWaring"></el-amap-marker>
      <el-amap-marker
        v-if="!isWaring"
        :icon="warIcon"
        vid=""
        v-for="(item, index) of markers"
        :key="index"
        :position="item.position"
        :events="item.loca"
        :animation="item.animate && aniIndex ? 'AMAP_ANIMATION_BOUNCE' : 'AMAP_ANIMATION_NONE'"
      ></el-amap-marker>
      <el-amap-text :zIndex="99999" :visible="item.showmod || showmodall" v-for="item in markers" :text="item.text" :offset="[0, 30]" :position="item.position"></el-amap-text>

      <!-- <info @local="showpos"></info> -->
    </el-amap>
    <!-- {{ markers }} -->
    <div
      style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
      "
      v-show="bimStaus"
    >
      <iframe :src="bimUrl || ''" frameborder="0" width="100%" height="100%"></iframe>
    </div>
    <!-- 联网单位 舒服 -->
    <div style="width: 100%; height: 100%" class="flex" v-if="$store.state.user.userInfo.natureId == 2">
      <!-- 数据分析单位页 -->
      <unit-page :lateDate="lateDate"> </unit-page>
      <!-- <lwnav></lwnav> -->
      <!-- <div
        class="flex"
        style="
          height: 100%;
          width: 100%;
          background: #f4f7ff;
          flex-direction: column;
        "
      > -->
      <!-- <usernav></usernav> -->
      <!-- <div class="lw-main flex flex1" style="flex-direction: column">
          <div class="lw-menu flex">
            <div class="hj-toast">
              <el-card
                shadow="never"
                style="height: 100%; border: none"
                :body-style="{
                  padding: '15px ',
                  height: '100%',
                  display: 'flex',
                  background: '#F4F7FF',
                }"
              > -->
      <!-- <div :class="isWaring ? 'firewaring' : 'fire'" style="flex: 1; padding: 20px; border-radius: 5px; cursor:pointer" @click="$store.commit('SHOWBJlIST', true)">
                  <div class="fire-logo" style="height: 55%">
                    <img src="@/assets/img/point.gif" alt="" style="width: 100%; height: 100%" v-if="isWaring" />
                    <img src="@/assets/img/lwhuojing.png" alt="" style="width: 100%; height: 100%" v-else />
                  </div>
                  <div class="fire-botton center">报警</div>
                </div>
              </el-card>
            </div>
            <div class="menu-cont flex1 ml20">
              <el-row :gutter="40">
                <el-col :span="6" v-for="(item, index) in lwmenu" v-if="index <= 3" class="cursor">
                  <el-card
                    style="border: none"
                    shadow="never"
                    border="none"
                    @click.native="linkfaci(index)"
                    :body-style="{
                      padding: '15px',
                      backgroundImage: item.url ? `url(${require('@/assets/img/menu_nav/' + item.url)})` : '',
                      backgroundSize: '100%',
                      backgroundSize: '100% 100%',
                      backgroundRepeat: 'no-repeat',
                    }"
                  > -->
      <!-- <div class="menu-item flex">
                      <span class="menu-font">{{ item.title }}</span> -->
      <!-- <img src="@/assets/img/hj-notice.png" alt="" width="20%"> -->
      <!-- </div>
                  </el-card>
                </el-col>
              </el-row>
              <el-row :gutter="40" class="mt20">
                <el-col :span="6" v-for="(item, index) in lwmenu" v-if="index > 3" class="cursor">
                  <el-card
                    style="border: none"
                    shadow="never"
                    border="none"
                    :body-style="{
                      padding: '15px',
                      backgroundImage: item.url ? `url(${require('@/assets/img/menu_nav/' + item.url)})` : '',
                      backgroundSize: '100% 100%',
                      backgroundRepeat: 'no-repeat',
                    }"
                    @click.native="linkfaci(index)"
                  >
                    <div class="menu-item">
                      <span class="menu-font">{{ item.title }}</span>
                    </div> -->
      <!-- </el-card>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="flex1" style="boxsizing: border-box; padding: 0 15px 0;"><div class="tab2" id="tab2"></div></div>
          <div class="copyright center">
            <span>技术支持:青岛同人建筑防火有限公司</span>
            <span class="ml20">地址:山东省青岛市市北区鞍山路17号浪潮大数据产业园A座F6-03-1</span>
            <span class="ml20">电话:0532-66013211/0532-82872119</span>
          </div>
        </div>
      </div> -->
    </div>
    <info @local="showpos" v-if="$store.state.user.userInfo.natureId == 1 || $store.state.user.userInfo.natureId == 3"></info>

    <!-- <info @local="showpos" v-if="$store.state.user.company.cCompanyNum==='aaa'"></info> -->

    <!-- 接警用户 -->

    <div style="height:95%" v-if="$store.state.user.userInfo.natureId == 4"><jiejing></jiejing></div>

    <el-dialog title="单位详情" style="min-height: 500px" :visible.sync="showmod" width="90%" :close-on-click-modal="false">
      <company :c_num="c_num" />
    </el-dialog>
  </div>
</template>

<script>
import info from './info';
import { mapState } from 'vuex';
import icon from '@/assets/img/dian_bao.png';
import warIcon from '@/assets/img/io1.png';
import remoteLoad from '@/utils/remoteload.js';
import VueAMap from 'vue-amap'; // 高德
VueAMap.initAMapApiLoader({
  //高德地图
  key: 'd5f59a5536ef668a67f92a4ed62ad773',
  plugin: ['AMap.DistrictSearch'],
  v: '1.4.4',
});
import company from '@/components/company.vue';
import lwnav from '@/components/Lwnav.vue';
import usernav from '@/components/usernav.vue';
import echarts from 'echarts';
import jiejing from '../jiejing/index';
import unitPage from '../../views/report/report-list.vue';
export default {
  inject: ['reload'], //注入reload方法
  components: { info, company, lwnav, usernav, jiejing, unitPage },
  computed: {
    ...mapState(['isMute', 'isWaring', 'bjList', 'bimStaus', 'bimUrl']),
  },
  data() {
    return {
      Loading: true,
      position: [119.97, 36.77],
      zoom: 13,
      aniIndex: null,
      icon: icon,
      warIcon,
      lateDate: false,
      componentMarker: {
        position: [119.97, 36.77],
      },
      showmodall: false,
      markers: [],
      prov: JSON.parse(localStorage.getItem('userInfo')),
      showmod: false,
      c_num: '',
      showMoreListDia: false,
      lwmenu: [
        {
          title: 'BIM展示',
          url: 'bim.png',
        },
        {
          title: '水系统',
          url: 'water.png',
        },
        {
          title: '电气监控',
          url: 'ele.png',
        },
        {
          title: '视频监控',
          url: 'video.png',
        },
        {
          title: '消防水泵',
          url: 'beng.png',
        },
        {
          title: '防风排烟机',
          url: 'paiyan.png',
        },
        {
          title: '无线燃气',
          url: 'gas.png',
        },
        {
          title: '无线烟感',
          url: 'smoke.png',
        },
      ],
      texts: [
        {
          position: [119.97, 36.77],
          text: 'hello world',
          offset: [0, 0],
          events: {
            click: () => {},
          },
        },
      ],
    };
  },

  watch: {
    bjList(val) {
      //收到报警
      this.position = [val[0].lon, val[0].lat];
    },
    isWaring(val) {
      this.zoom = val ? 15 : 13;
    },
  },
  // created() {
  //   // console.log(this.markers);
  //   // this.getList()
  // },
  // updated() {

  // },
  created() {
    if (this.$local.get('token')) {
      this.$router.replace('/');
    }
    if (this.$local.get('account')) {
      this.user = this.$local.get('account');
    }
    // if (this.$store.state.user.userInfo.natureId == 2) {
    //   this.$get('/trmoni/fireFacilitiesManage/policeButton', { companyId: this.$store.state.user.company.cCompanyNum }).then((res) => {
    //     // console.log(res, 'get status');
    //     this.lateDate = res.data;
    //   });
    // }
  },
  mounted() {
    this.$store.dispatch('GetInfo');
    this.Loading = false;

    // setTimeout(()=>{
    // this.setPosition&&this.setPosition();
    // })
    // console.log(11111);
    // console.log(`${this.$route.meta.ishome} 触发了 mounted 钩子函数`)

    // window.location.reload();

    this.setPosition();

    // this.makeline();

    setTimeout(() => {
      if (this.$store.state.user.userInfo.natureId == 2) {
        this.$post('/monitor/yearbaojing').then((res) => {
          this.makeline(res);
        });
      }
    }, 100);
  },
  beforeRouteEnter(to, from, next) {
    // alert(JSON.stringify(from))
    if (from.name) {
      next((vm) => {
        setTimeout(() => {
          if (vm.$route.query.foreignToken) {
            vm.$router.push({ query: {} });
          }
        }, 100);
      });
    } else {
      setTimeout(() => {
        next((vm) => {
          if (vm.$route.query.foreignToken) {
            vm.$router.push({ query: {} });
            window.location.reload();
          }
        });
      }, 500);
    }
  },
  methods: {
    clickArrayMarker(marker) {},
    //  initMap() {
    //    console.log( amapManager)
    //   const map = amapManager.getMap()
    //   this.map = map
    // },
    linkfaci(index) {
      this.$router.push({
        path: '/facility',
        query: { index },
      });
    },

    remark() {
      this.markers[this.aniIndex].animate = false;
      return;
    },
    chous() {},
    showpos(val) {
      for (var i = 0; i < this.markers.length; i++) {
        if (this.markers[i].c_company_num === val) {
          this.position = [this.markers[i].position[0], this.markers[i].position[1]];
          this.markers[i].animate = true;
          this.aniIndex = true;
          // this.showmodall=true
          // console.log(this.zoom)
          this.zoom = 20;
        } else {
          this.markers[i].animate = false;
        }
      }
      // setTimeout(()=>{
      //   this.aniIndex = false

      // },30000)
    },

    //折线图
    makeline(arr1) {
      // arr1 = arr1.map(item => item || null);
      let data = [],
        date = [];
      arr1.data.forEach((item) => {
        data.unshift(item.count);
        date.unshift(item.date);
      });
      echarts.init(document.getElementById('tab2')).setOption({
        title: {
          text: `${this.$store.state.user.company.cName}火警数量趋势图`,
          x: 'center',
          top: '20',
          textStyle: {
            fontSize: 24,
          },
        },
        tooltip: {
          trigger: 'axis',

          axisPointer: {
            type: 'cross',
            // label: {
            //   backgroundColor: "red ",
            // },
          },
        },
        xAxis: [
          {
            type: 'category',
            name: '月份',
            boundaryGap: false,
            data: date,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#000',
                fontSize: '7px',
              },
            },
          },
        ],
        grid: {
          left: 80,
          right: 80,
          bottom: 70,
          top: 70,
        },
        yAxis: [
          {
            name: '火警数量',
            type: 'value',
            axisLabel: {
              show: true,
              textStyle: {
                color: '#000',
              },
            },
          },
        ],
        dataZoom: [
          {
            start: 2,
            type: 'inside',
          },
          {
            type: 'slider',
            start: 2,
          },
        ],
        series: [
          {
            name: '火警数量',
            type: 'line',
            stack: '总量',
            symbol: 'none',
            areaStyle: {
              color: '#CFEBFF',
            },
            lineStyle: {
              color: '#14BB88',
            },
            data: data,
          },
        ],
      });
      this.deviceload = false;
    },

    getList(res) {
      var arr = [];
      res.data.map((item, index) => {
        // console.log(item,11)
        if (item.lon && item.lat) {
          var obj = {};
          obj.position = [Number(item.lon), Number(item.lat)];

          (obj.showmod = false),
            // <div>单位编号: <span>${item.cNumber}</span></div>
            (obj.text = `<div>单位名称: <span>${item.cName}</span></div>
                       
                         <div>单位地址: <span>${item.cAddress}</span></div>
            `);
          obj.cCompanyNum = item.cCompanyNum;
          (obj.loca = {
            click: () => {
              // this.$router.push('/report/report-list');
              log(`点击了标号,标号ID： ${item.cCompanyNum}`);
              this.$router.push({
                path: `/report/report-list?companyNum=${item.cCompanyNum}&name=${item.cName}`,
              });
              let val = {
                c_company_num: item.cCompanyNum,
                c_name: item.cName,
              };
              this.$local.save('company', val);
            },
            mouseover: () => {
              // this.markers[index].showmod = true;
              this.markers.map((it, idx) => {
                if (it.cCompanyNum === item.cCompanyNum) {
                  // console.log(this.markers[idx]);
                  // console.log(this.markers[idx].showmod);
                  this.markers[idx].showmod = true;
                }
              });
            },
            mouseout: () => {
              // this.markers[index].showmod = false;
              this.markers.map((it, idx) => {
                if (it.cCompanyNum === item.cCompanyNum) {
                  this.markers[idx].showmod = false;
                }
              });
            },
          }),
            arr.push(obj);
        }
      });
      this.markers = arr;
      // 字段為xxxx就重新賦值
      // var prov = JSON.parse(localStorage.getItem("userInfo"));
      // console.log(prov.region);
      // if (this.prov.region === 1) {
      //   // this.position = [121.5273285, 31.21315058];
      //   this.position = [ 120.36173, 36.082949];
      //   // window.location.reload()
      // } else if (this.prov.region === 2) {
      //   // this.position = [117.126328, 36.655321];
      //   this.position = [117.126328,  36.655321];
      //   this.zoom = 10;
      //   // window.location.reload()
      // }
    },
    setPosition() {
      if (this.prov.region === 1) {
        // this.position = [121.5273285, 31.21315058];
        this.position = [119.97, 36.77];
        // window.location.reload()
      } else if (this.prov.region === 2) {
        // this.position = [117.126328, 36.655321];
        this.position = [119.97, 36.77];
        this.zoom = 10;
        // window.location.reload()
      }
    },
  },
};
</script>

<style lang="scss">
.home {
  width: 100%;
  flex: 1;
  position: relative;
}
.tab2 {
  background: #fff;
  border-radius: 10px;
  height: 100%;
}
.menu-item {
  height: 6vw;
}
.amap-box {
  width: 100%;
  height: 100%;
}

.home {
  // background-color: #080f1c;
  position: relative;
}
.menu-cont {
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 15px;
}
.amap-icon {
  img {
    width: 40px;
  }
  img[src='/img/dian_bao.8d7abb60.png'] {
    animation: mymove 1s infinite;
    animation-direction: alternate;
  }
}
.menu-font {
  color: #468eff;
  font-weight: 900;
  font-size: 18px;
  display: flex;
  padding-top: 20px;
}
.fire-botton {
  padding: 15px;
  border-radius: 10px;
  box-shadow: 2px 2px 10px #999;
  margin-top: 20px;
  color: red;
  font-weight: 900;
  cursor: pointer;
  font-size: 25px;
  background: #fff;
}
.lw-menu {
  justify-content: space-between;
  // height: 20vw;
  box-sizing: border-box;
  padding: 15px;
}
.hj-toast {
  width: 17%;
}
.copyright {
  margin-top: 10px;
  margin-bottom: 10px;
  height: 40px;
  font-size: 10px;
  color: #7b879f;
  background: #e9eff5;
}
.fire {
  background: #ffb800;
}
.firewaring {
  animation: warningmove 0.3s infinite;
  animation-direction: alternate;
}
@keyframes mymove {
  from {
    transform: translateY(-20px);
  }
  to {
    transform: translateY(0px);
  }
}
@keyframes warningmove {
  from {
    background: #ed1c24;
  }
  to {
    background: #ffb800;
  }
}
</style>
